import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { CardContainer } from "../../components/Card/components/CardContainer/CardContainer";
import styles from "./sk-Card.module.css";
export const Card = ({ children, className, onBackground = "light", orientation = "vertical", ...restProps }) => {
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${onBackground}`]]: !!onBackground,
        [styles[`main--${orientation}`]]: !!orientation,
    });
    const isResponsive = orientation === "responsive";
    return (_jsx(CardContainer, { isResponsive: isResponsive, children: _jsx("div", { className: mainClassNames, ...restProps, children: children }) }));
};
Card.displayName = "Card";
//# sourceMappingURL=Card.js.map